<script lang="ts">
  import type { schema } from "@editor/schema";
  import { getNewsletterStores } from "../newsletterStores";
  import Block from "./Block.svelte";
  import { newBlock } from "./blocksConfig";

  export let block: schema.PlaceholderBlock;
  const { design, content, api } = getNewsletterStores();

  function switchBlockType(toType: schema.BlockType, layout: "lg" | "columns") {
    const b = { ...newBlock(block._id, toType, layout), _o: block._o };

    // override block
    content.setBlock(block._id, b, /* don't unlock */ false);
  }
</script>

<Block {block} on:click on:delete on:duplicate let:isEmpty showEmpty size="full" preventClicks={false}>
  {#if block._l === "insert-photos"}
    <div class="wrap flex p-2">
      <div
        class="clickable hover:bg-success-600 m-2 flex flex-grow flex-col items-center justify-center rounded bg-white p-2 text-nxgray-600 shadow hover:text-white"
        on:click={() => switchBlockType("items", "columns")}>
        <i class="material-icons text-4xl text-current">view_column</i>
        <h4 class="text-sm font-bold text-current">Columns</h4>
      </div>
      <div
        class="clickable hover:bg-success-600 m-2 flex flex-grow flex-col items-center justify-center rounded bg-white p-2 text-nxgray-600 shadow hover:text-white"
        on:click={() => switchBlockType("image.single", "lg")}>
        <i class="material-icons text-4xl text-current">photo</i>
        <h4 class="text-sm font-bold text-current">Big Photo</h4>
      </div>
    </div>
  {/if}
</Block>

<style>
  .wrap {
    background: #b3e2d0;
  }
</style>
